import React from 'react';
import styled from 'styled-components';
import { BlueButton } from '../../components/StyledComponents';
import FirstNameIcon from '../../assets/formComponents/FirstNameIcon.svg';
import EmailIcon from '../../assets/formComponents/emailIcon.svg';
// import PhoneIcon from '../../assets/formComponents/phone.svg';
import {
  StyledInputs,
  PasswordMatchError,
} from '../../components/HomePage/EsperSignUpFormComponent';
import Axios from 'axios';
import { navigate } from 'gatsby';
import { validatePhone } from '../../globalFunctions';
import apiHost from '../../apiHost';
import PhoneInputClass from '../../components/Esper/ContactUs/PhoneInput';
import { getLanguageFromPath } from '../../helpers';

const RequestDemoFormComponent = styled.div`
  font-size: 14px;
  text-align: center;
  @media (max-width: 1000px) {
    position: relative;
    top: unset;
    display: grid;
    justify-content: center;
    right: unset;
    padding: 0rem;
    width: 90%;
    max-width: 450px;
    margin: auto;
    margin-top: 2rem;
  }
`;
export const RequestDemoFormContainer = styled.div`
  border-radius: 4px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
  background-color: #ffffff;
  display: grid;
  /* justify-items: center; */
  padding-top: 2rem;
  padding-bottom: 3rem;
  @media (max-width: 520px) {
    /* width: 100%; */
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const RequestDemoTitle = styled.h1`
  font-size: 28px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
`;
const ButtonWrapper = styled.div`
  display: flex;
`;
const BlueButtonNew = styled(BlueButton)`
  margin-top: 0rem;
  width: 10rem;
  margin: 0 !important;
  margin-right: 1rem !important;
  margin-top: 10px;
  box-shadow: none;

  @media (max-width: 520px) {
    width: 6rem;
  }
`;

const CancelButton = styled(BlueButtonNew)`
  margin-right: 0;
  background: white;
  color: #151828;
  border: solid 1px #979797;
`;

export default class RequestDemoForm extends React.Component<any, any> {
  state = {
    name: '',
    email: '',
    message: '',
    date: new Date(),
    contact: '',
    deviceNumber: '',
    defaultCountry: {
      icon: '🇺🇲',
      name: 'United States',
      abbr: 'US',
      code: '1',
      suggested: true,
    },
    contactFocus: false,
    nameError: false,
    emailError: false,
    messageError: false,
    contactError: false,
    deviceNumberError: false,
    preferredDateError: false,
    submitError: false,
    loaded: false,
    langKey: 'en',
  };

  isAllValid = () =>
    !(
      this.state.messageError ||
      this.state.contactError ||
      this.state.nameError ||
      this.state.preferredDateError ||
      this.state.deviceNumberError ||
      this.state.emailError
    );

  validateAll = () => {
    this.validateMessage();
    this.validateContact();
    this.validateFullName();
    this.validateEmail();
  };

  componentDidMount() {
    this.setState({
      loaded: true,
      langKey: getLanguageFromPath(window.location.pathname)
        ? getLanguageFromPath(window.location.pathname)
        : 'en',
    });
  }
  navigateThankyou = () => {
    localStorage.setItem('prevPage', 'hardware');
    // navigate('/submitted');
    navigate(
      this.state.langKey !== 'en'
        ? `/${this.state.langKey}/submitted`
        : '/submitted'
    );
  };

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  sendData = () => {
    this.validateAll();
    if (this.isAllValid()) {
      localStorage.setItem('customerName', `${this.state.name}`);
      localStorage.setItem('demoTime', `${this.state.date.toISOString()}`);
      const hubspotToken = this.getCookieValue('hubspotutk');
      Axios({
        url:
          'https://api.hsforms.com/submissions/v3/integration/submit/5868902/5768e2d9-8d0c-45df-a314-28a323e59298',
        method: 'POST',
        data: {
          fields: [
            {
              name: 'email',
              value: this.state.email,
            },
            {
              name: 'firstname',
              value: this.state.name,
            },
            {
              name: 'phone',
              value: `${
                this.state.defaultCountry
                  ? `+${this.state.defaultCountry.code} `
                  : ''
              }${this.state.contact.trim()}`,
            },
            {
              name: 'message',
              value: this.state.message,
            },

            {
              name: 'language_key',
              value: this.state.langKey,
            },
          ],
          context: {
            hutk: hubspotToken,
            pageUri: window.location.href,
            pageName: document.title,
          },
        },
      })
        .then(() => {
          this.setState({
            messageError: false,
            contactError: false,
            nameError: false,
            emailError: false,
            deviceNumberError: false,
            preferredDateError: false,
            email: '',
            name: '',
            message: '',
            contact: '',
            date: '',
            deviceNumber: '',
          });
          this.navigateThankyou();
        })
        .catch((error: any) => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            error.response.data.errors.forEach((item: any) => {
              if (item.message.includes('fields.number_of_device')) {
                this.setState({ deviceNumberError: true });
              } else if (item.message.includes('fields.email')) {
                this.setState({ emailError: true });
              } else if (item.message.includes('fields.phone')) {
                this.setState({ contactError: true });
              } else {
                console.log('error');
              }
            });
          }
        });
    } else {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Request Demo Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };

  // VALIDATIONS

  validateFullName = () => {
    if (this.state.name.length === 0 || this.state.name.length > 30) {
      this.setState({
        nameError: true,
      });
    } else {
      this.setState({
        nameError: false,
      });
    }
  };

  validateEmail = (isNotOnFocus?: any) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Request Demo Form`,
          failure: false,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      if (isNotOnFocus) {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      } else {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      }
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  validateMessage = () => {
    if (this.state.message.length === 0 || this.state.message.length > 30) {
      this.setState({
        messageError: true,
      });
    } else {
      this.setState({
        messageError: false,
      });
    }
  };

  validateContact = () => {
    if (!validatePhone(this.state.contact)) {
      this.setState({
        contactError: true,
        contactFocus: true,
        contactErrorMessage: 'Please enter a valid contact number',
      });
    } else {
      this.setState({
        contactError: false,
        contactFocus: true,
        contactErrorMessage: '',
      });
    }
  };

  //   Input Recievers

  handleCountrySelect = (event: any) => {
    this.setState({ defaultCountry: event });
  };
  handleNameChange = (event: any) =>
    this.setState({ name: event.target.value });
  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });
  handleMessageChange = (event: any) =>
    this.setState({ message: event.target.value });
  handleContactChange = (event: any) =>
    this.setState({ contact: event.target.value });
  onKeyPress = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (/\+|-/.test(keyValue)) {
      event.preventDefault();
    }
  };

  handleFocusContact = () => this.setState({ contactFocus: true });
  render() {
    return (
      <RequestDemoFormComponent>
        <RequestDemoFormContainer>
          <RequestDemoTitle>Connect with Esper</RequestDemoTitle>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="name"
              value={this.state.name}
              aria-label="Full Name"
              backgroundImage={this.state.loaded && FirstNameIcon}
              maxLength={149}
              onChange={this.handleNameChange}
              onBlur={this.validateFullName}
              error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={'Full Name'}
              name="Full Name"
            />
            <PasswordMatchError id="name-error">
              {this.state.nameError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid name
                </>
              ) : (
                this.state.nameError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.name.length > 1
                      ? 'Please enter a valid name'
                      : 'Please enter your name'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="email"
              value={this.state.email}
              aria-label="Email"
              backgroundImage={this.state.loaded && EmailIcon}
              maxLength={149}
              onChange={this.handleEmailChange}
              onBlur={this.validateEmail}
              error={this.state.emailError || this.state.submitError}
              type="email"
              placeholder={'Work Email'}
              name="Work Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.emailError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid email address
                </>
              ) : (
                this.state.emailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? 'Please enter a valid email address'
                      : 'Please enter an email address'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <PhoneInputClass
            handleFocusContact={this.handleFocusContact}
            handleContactChange={this.handleContactChange}
            validateContactNumber={this.validateContact}
            handleCountrySelect={this.handleCountrySelect}
            defaultCountry={this.state.defaultCountry}
            contactNumber={this.state.contact}
            contactError={this.state.contactError}
            submitError={this.state.submitError}
            messages={this.props.messages}
          />
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="message"
              value={this.state.message}
              aria-label="message"
              // backgroundImage={this.state.loaded && CompanyIcon}
              maxLength={149}
              onChange={this.handleMessageChange}
              onBlur={this.validateMessage}
              error={this.state.messageError || this.state.submitError}
              type="text"
              placeholder={'Message'}
              name="message"
            />
            <PasswordMatchError id="message-error">
              {this.state.messageError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid message
                </>
              ) : (
                this.state.messageError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.message.length > 1
                      ? 'Please enter a valid message'
                      : 'Please enter your message'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>

          <div style={{ display: 'grid', marginTop: '8px' }}>
            <ButtonWrapper>
              <CancelButton onClick={this.props.close}>Cancel</CancelButton>
              <BlueButtonNew onClick={this.sendData}>Submit</BlueButtonNew>
            </ButtonWrapper>
          </div>
        </RequestDemoFormContainer>
      </RequestDemoFormComponent>
    );
  }
}
